export default __webpack_public_path__ + "static/media/Pretendard-Medium.f902522b.woff";